import { Copy } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Switch } from "@/components/ui/switch";
import { api } from "@/lib/api";

export const ShareDialog = ({ open, onOpenChange, album, onChange }) => {
  const link = album.share_url_path ? window.location.origin + album.share_url_path : "";
  const toggle = async (enabled) => onChange((await api.post(`/albums/${album.id}/share`, { enabled })).data);
  const copy = async () => {
    await navigator.clipboard?.writeText(link).catch(() => {});
    toast.success("Link copied");
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md bg-[#f4f3f0]" data-testid="share-dialog">
        <DialogHeader>
          <DialogTitle className="serif text-2xl">Share “{album.name}”</DialogTitle>
          <DialogDescription>Anyone with the link can view this album. Turning it off revokes the link immediately.</DialogDescription>
        </DialogHeader>
        <label className="flex items-center justify-between py-2">
          <span className="text-sm">Public link</span>
          <Switch checked={album.share_enabled} onCheckedChange={toggle} data-testid="album-public-share-toggle" />
        </label>
        {link && (
          <div className="flex gap-2">
            <input readOnly value={link} className="login-input !mb-0 flex-1 text-xs" data-testid="album-share-link-input" />
            <button className="btn-ink !px-4" onClick={copy} data-testid="album-copy-share-link"><Copy size={16} /></button>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
